import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function ContactConcerns() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2752">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-8" data-id="element-2753">
        <div className="flex items-start gap-4 p-5 rounded-xl border-2" style={{
        backgroundColor: '#fffbeb',
        borderColor: '#c8a84b'
      }} data-id="element-2754">
          <PhoneIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-2755" />
          <p className="text-base font-semibold" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2756">
            If you feel that we are not abiding by this privacy policy, you
            should contact us immediately via telephone at{' '}
            <a href="tel:8109193724" className="underline hover:opacity-80" style={{
            color: '#1e3d2f'
          }} data-id="element-2757">
              810-919-3724
            </a>{' '}
            or via email.
          </p>
        </div>
      </div>
    </div>;
}